<request [state]="viewState.Details"></request>
